import { PartForSaleDto, UnitOtherPartDto } from 'api';

export const getOtherPartId = (entity: UnitOtherPartDto) =>
	entity.partNumber + (entity.serialNumber || '');

export const getPartForSaleId = (entity: PartForSaleDto) =>
	entity.partNumber + (entity.serialNumber || '');
